import React from 'react'
import { Button, Grid } from '@material-ui/core'
import { stepOneSchema } from '../../schemas'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-material-ui'

import { PhoneField } from 'civic-champs-shared/formik/components'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

function StepOne(props) {
  const { onSubmit, email, phoneNumber, organization, group, classes } = props
  const isAboveSmall = isWidthUp('sm', props.width)

  return (
    <>
      <div className="invite-header">
        <p style={{ textAlign: 'center' }}>
          To apply for {organization.name}'s Group: {group.name}, first provide either your email address or phone
          number. If you already have a Civic Champs account, you'll want to enter the same contact information as your
          login.
        </p>
      </div>
      <Formik
        initialValues={{
          email,
          phoneNumber,
        }}
        validationSchema={stepOneSchema}
        onSubmit={values => onSubmit(stepOneSchema.cast(values))}
        validateOnBlur={true}
        validateOnChange={false}
      >
        {({ handleSubmit, isSubmitting, values }) => (
          <form>
            <Grid container spacing={2} direction="column" justify="center" alignItems="center">
              <Grid item container spacing={2} justify="center">
                <Grid item>
                  <Field
                    fullWidth={!isAboveSmall}
                    component={TextField}
                    label="Email"
                    name="email"
                    variant="outlined"
                    className={classes.input}
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2} justify="center">
                <Grid item>
                  <Field
                    fullWidth={!isAboveSmall}
                    component={PhoneField}
                    label="Mobile Number"
                    name="phoneNumber"
                    variant="outlined"
                    className={classes.input}
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2} justify="center">
                <Button
                  type="submit"
                  className="submit button"
                  disabled={isSubmitting || (!values.email && !values.phoneNumber)}
                  onClick={handleSubmit}
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  )
}

export default withWidth()(StepOne)
